<template>
  <div class="about">
    <div class="container banner">
      <img src="../../static/img/about/banner.png" class="top-banner" alt="">
      <div class="content">
        <div class="bread">
          您现在的位置：
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item >关于合美</el-breadcrumb-item>
            <el-breadcrumb-item>专家团队</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="about-title">
          <h3 class="meal-title"><span class="title-line"></span>专家团队<span class="title-line"></span></h3>
          <p class="sub-title">Brand story</p>
        </div>
        <div class="about-article">
          <div class="pre-text">
            合美秉承管家式服务理念，不同专业领域的资深专家对产后母婴提供“多对一”专业呵护服务——妇产科专家、盆底专科专家、新生儿专家、儿童保健专家、中医专家、高级营养师、医疗美容管家等多对一服务，为选择合美月子中心的妈妈和宝宝保驾护航。
          </div>
          <div class="taggle-box">
            <ul>
              <li @click="setActive(item.id)" class="fun-carousel" :class="{'active':item.id===index?true:false}" v-for="item in diaryCarList" :key="item.id">
               {{item.name}}
              </li>
            </ul>
          </div>
          <div style="clear: both"></div>
          <div class="team-group">
            <ul>
              <!--v-for="item in teamList" :key="item.id"-->
              <li class="team-item" v-for="item in teamList" :key="item.id">
                <div class="img-box">
                  <img :src="item.src" alt="">
                </div>
                <div class="team-intro">
                  <p class="ann">{{item.ann}}</p>
                  <i class="line"></i>
                  <p class="name" v-if="item.name"><span class="name-g"><i class="icon-sq"></i>姓名：</span>{{item.name}}</p>
                  <div class="team-content" v-html="item.cons"></div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "aboutTeam",
    data(){
      return{
        index:1,
        diaryCarList:[
          {
            name:'二十载专业成就卓越品质 ',
            id:1
          },
          {
            name:'合美产后康复王牌团队 ',
            id:2
          },
          {
            name:'高级营养师+星级大厨',
            id:3
          },
          {
            name:'强强联合铸造合美实力',
            id:4
          },
        ],
        teamList:[],
        teamListF:[
          // {
          //   id:1,
          //   src:'../../static/img/about/01.png',
          //   ann:'合美店长、29年新生儿护理、产康经验',
          //   name:'叶蓉',
          //   cons:'历任常州市儿童医院新生儿护理组长、新寰亚月子会所护士长、孕产妇健康教育讲师。接受过多项专业技术特殊训练（产后修复技术、新生儿护理及重儿抢救、婴幼儿高压氧舱操作技术等）。并屡获优秀护士、嘉奖等表彰与奖励，期间多次荣立“三等功”，发表省级论文数篇。管理中注重团队建设、以精细化管理不断开拓创新。',
          // },
          {
            id:2,
            src:'../../static/img/about/02.png',
            ann:'妇产科临床工作20余年、产科副主任',
            name:'周小珏',
            cons:'具备扎实的理论基础与丰富的临床经验，擅长孕产妇保健及难产处理、诊治各类妊娠合并症及并发症。尤其对危重孕产妇抢救合高难度产科手术有丰富临床经验。曾参与江苏省卫计委援陕医疗队，发表多篇核心论文。',
          },
          {
            id:3,
            src:'../../static/img/about/03.png',
            ann:'儿科工作20余年、儿科主任医师',
            name:'王瑛',
            cons:'常州市医学会儿科医疗事故鉴定库专家、江苏省营养学会委员、熟练诊治儿科常见病、多发病，现主要从事早产儿管理如追赶性生长、儿童营养、代谢性疾病等工作，有丰富的临床经验及独到专业见解。',
          },
        ],
        teamListS:[
          {
            id:1,
            src:'../../static/img/about/04.png',
            ann:'特邀留美医学博士、和睦家产康专家、中美职业资质医师',
            name:'张晓东',
            cons:'作为中美两国职业资质医师、康复科医师，曾留学美国德克萨斯派克脊柱神经矫正康复研究院，开设私人诊所，并为国内外数位明星妈妈提供产康解决方案。张晓东博士及其团队在合美定期坐诊，除常规的骨伤康复和脊柱康复，提供包括臀部修复、产后骨盆恢复、产后腹部恢复、产后脊柱康复等专业产康服务；张博士擅长中西医结合产后康复治疗，运用美国Thompson技术，将理疗、整骨、胶原蛋白导入相结合，再通过理疗和专业整骨手法，让骨盆恢复其自然生理机能，彻底为孕妈深度剖析解决问题。',
          },
          {
            id:2,
            src:'../../static/img/about/05.png',
            ann:'康复及护理师',
            name:'于立娜',
            cons:'曾任北京国际医疗中心康复及护理师、北京和睦家医院康复及护理师。任职期间为21世纪医院、美中宜和妇儿医院、新世纪妇儿医院、巍阁产后修养中心提供专业产后康复技术服务，是明星妈妈陈某、孙某等专属产后康复治疗护理师。',
          },
        ],
        teamListT:[
          {
            id:1,
            src:'../../static/img/about/06.png',
            ann:'高级营养师+星级大厨',
            name:'',
            cons:'合美科学膳食由五星级酒店行政总厨率资深厨师、并聘请营养专家共同组成，进行产品开发、食材选择、营养调配、菜品烹制。并针对孕产妇个体差异，为其量身定制个性营养月子餐及药膳调理，为产妇提供餐餐不同、阶段补养，吃出苗条，吃出健康。',
          },
        ],
        teamListL:[
          {
            id:1,
            src:'../../static/img/about/07.png',
            ann:'强强联合铸造合美实力',
            name:'',
            cons:'合美月子中心与北京和睦家双方已达成共识，拟在孕产健康咨询、早产儿健康护理、产后康复体验等多个方面展开深度合作，共同发展推进功能完善、体验一流、健康引领的母婴医疗服务体系。\n' +
              '<br><br>' +
              '合美将以国际化的医疗团队、独有的私家母婴护理，尽心为产后母婴健康提供更科学与高水平的医疗保健服务。以全新理念、专业技术、优质资源引领母婴生活方式的变革。',
          },
        ]
      }
    },
    created(){
      this.setActive(1);
    },
    methods:{
      setActive:function (id) {
        this.index = id;
        switch (id) {
          case 1:
            this.teamList = this.teamListF;
            break;
          case 2:
            this.teamList = this.teamListS;
            break;
          case 3:
            this.teamList = this.teamListT;
            break;
          case 4:
            this.teamList = this.teamListL;
            break;
        }
      },
    }
  }
</script>

<style scoped lang="less">
  .about{
    .banner{
      .top-banner{
        width: 100%;
        margin-bottom: 20px;
      }
      .bread{
        margin-bottom: 20px;
        font-size: 12px;
        color:#999999;
        .el-breadcrumb{
          vertical-align: middle;
          display: inline-block;
          span{
            font-size: 12px;
            color:#999999;
          }
        }
      }
      .about-title{
        margin-bottom: 32px;
      }
      .about-article{
        margin-bottom: 80px;
        .pre-text{
          text-indent: 20px;
          line-height: 24px;
          font-size: 14px;
          color:#666666;
          margin-bottom: 36px;
        }
        .taggle-box{
          margin-bottom: 50px;
          ul{
            display: flex;
            flex-direction: row;
            justify-content: center;
            .fun-carousel{
              width: 186px;
              height: 36px;
              color:#666666;
              text-align: center;
              line-height: 36px;
              border-radius: 18px;
              float: left;
              cursor: pointer;
              border: 1px solid #666666;
              margin-right: 30px;
              &:last-child{
                margin-right: 0;
              }
            }
            .fun-carousel.active{
              background-color: #c2874e;
              color:#ffffff;
              border-color: #c2874e;
            }
          }
        }
        .team-item{
          margin-bottom: 40px;
          width: 100%;
          height: 346px;
          background-color: #fbfbfb;
          display: flex;
          flex-direction: row;
          justify-content: left;
          .img-box{
            height: 346px;
            width: 520px;
            display: flex;
            margin-right: 32px;
            justify-content: center;
            img{
              height: 100%;
            }
          }
          .team-intro{
            width: 676px;
            padding: 36px 0;
            display: flex;
            flex-direction: column;
            .ann{
              font-size: 18px;
              line-height: 22px;
              color:#333333;
              margin-bottom: 12px;
            }
            .line{
              display: block;
              height: 3px;
              width: 42px;
              margin-bottom: 18px;
              background-color: #535353;
            }
            .name{
              margin-bottom: 40px;
              font-size: 18px;
              line-height: 22px;
              color:#333333;
              .name-g{
                color:#535353;
                font-size: 14px;
                line-height:18px;
                margin-right: 5px;
                .icon-sq{
                  display: inline-block;
                  width: 10px;
                  height: 10px;
                  margin-right: 5px;
                  background-image: url('../../static/img/about/icon-sq.png');
                  -webkit-background-size: 10px 10px;
                  background-size: 10px 10px;
                }
              }
            }
            .team-content{
              font-size: 14px;
              line-height: 28px;
              color:#666666;
            }
          }
        }
      }
    }
  }
  .meal-title{
    margin-bottom: 8px;
    text-align: center;
    font-size: 28px;
    line-height: 32px;
    font-weight: 500;
    .title-line{
      width: 65px;
      height: 1px;
      margin:0 30px;
      display: inline-block;
      background-color: #cccccc;
      vertical-align: middle;
    }
  }
  .sub-title{
    color:#b3b3ba;
    text-align: center;
  }
</style>




// WEBPACK FOOTER //
// src/components/aboutTeam.vue